import React from "react";
import { useTranslation } from "react-i18next";

import {
  NavigationHeader,
  IProps as NavigationProps,
} from "adminComponents/molecules/NavigationHeader";
import { NotFoundModule } from "adminComponents/molecules/NotFoundModule";
import { TemplateWithVerticalCenteredContent } from "adminComponents/templates/TemplateWithVerticalCenteredContent";
import { usePageTitle } from "lib/hooks/usePageTitle";

export interface ITeacherProfileUnavailableScreenProps {
  navigationData: NavigationProps;
}

export const TeacherProfileUnavailableScreen: React.FC<
  ITeacherProfileUnavailableScreenProps
> = ({ navigationData }) => {
  const { t } = useTranslation("admin", {
    keyPrefix: "teacherProfileUnavailable",
    useSuspense: false,
  });

  usePageTitle(t("pageTitle"));

  return (
    <TemplateWithVerticalCenteredContent
      nav={<NavigationHeader {...navigationData} />}
    >
      <NotFoundModule title={t("heading")} description={t("description")} />
    </TemplateWithVerticalCenteredContent>
  );
};
